import React from 'react';
import { ReactComponent as CallMade } from '/src/assets/svg/icons/call_made.svg';

const Contact: React.FC = () => {
  return (
    <>
      <hr className='my-4' />
      <div className='content-bold'>Wir sind für dich da</div>
      <div className='content-normal'>
        Bei Fragen hilft dir unser Service-Team gerne weiter.
      </div>
      <div className='content-normal'>
        <div className='flex gap-1'>
          <div className='content-normal'>Telefon: </div>
          <a href='tel:+4940471048920' className='content-bold'>
            {' '}
            040 / 47104 - 8920
          </a>
        </div>
        <div className='flex gap-1'>
          <div className='content-normal'> Montag bis Freitag: </div>
          <div className='content-bold'> 09:00 – 18:00 Uhr</div>
        </div>
      </div>
      <div className='flex content-normal items-center gap-1'>
        <div className='content-normal'>E-Mail: </div>

        <a href={`mailto:marketplace@aldautomotive.com`}>
          <div className='content-bold flex'>
            <div>Marketplace@aldautomotive.com</div>
            <div className='align-bottom'>
              <CallMade />
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default Contact;
